import { useRouter } from 'next/router';

import { icon_search } from '@gn-audio/icons';

import { useFallbackTranslation } from '../../../utils/hooks';
import { JabraIcon } from '../../JabraIcon/JabraIcon';

type SearchButtonProps = {
  onClick: () => void;
  isActive?: boolean;
};

export const SearchButton = ({
  onClick,
  isActive,
}: SearchButtonProps): React.JSX.Element | null => {
  const router = useRouter();
  const { t } = useFallbackTranslation();
  const path = router.asPath;
  const hideSearchButton = path.includes('search') && !path.includes('/support/');

  if (hideSearchButton) return null;

  return (
    <button
      title={t('topmenu.Search')}
      aria-label={t('topmenu.Search')}
      onClick={onClick}
      className={`search-button btn-top-menu ${isActive ? 'active' : ''}`}
    >
      <JabraIcon Icon={icon_search} className="size-6" />
    </button>
  );
};
